
















import { Component, Prop, Vue } from "vue-property-decorator";
import { RawLocation } from "vue-router";

import { Dictionary } from "@/lib/Dictionary.type";

import RejectionReasonEditForm from "./RejectionReasonEditForm.vue";

import RejectionReason from "../rejection-reason.model";

@Component({
  metaInfo() {
    return {
      title: "Add Rejection Reason",
    };
  },
  components: {
    RejectionReasonEditForm,
  },
})
export default class RejectionReasonAddPage extends Vue {
  @Prop()
  public readonly listQuery?: Dictionary<string[]>;

  @Prop()
  public readonly query!: Record<string, unknown>;

  public onCancel(): void {
    void this.$router.push({
      name: "RejectionReasonsListPage",
      query: this.listQuery,
    });
  }

  public onSuccess(rejectionReason: RejectionReason): void {
    const editPageUrl = this.generateItemLink(
      rejectionReason.id,
      this.query,
      this.listQuery
    );

    void this.$router.push(editPageUrl);
  }

  private generateItemLink(
    id: string,
    query: Record<string, unknown>,
    listQuery?: Record<string, unknown>
  ): RawLocation {
    return {
      name: "RejectionReasonEditPage",
      query: {
        id,
        query: JSON.stringify(query),
        listQuery: JSON.stringify(listQuery),
      },
    };
  }
}
